export default __webpack_public_path__ + "static/ai-9cf0058f135063bcaef4dee2ff504ef9.png";